import { MyFormItem, MyFormItemGroup } from "@components";
import { ExamGroup } from "@types";
import { InputNumber } from "antd";
import { useTranslation } from "react-i18next";

interface Props {
  examGroup: ExamGroup;
}

export const QuestionsRandom = ({ examGroup }: Props) => {
  const { t } = useTranslation();
  return (
    <MyFormItemGroup prefix={"examGroupProperties"}>
      <MyFormItem
        initialValue={examGroup.numberOfQuestionsInGroup}
        label={t("forms.questionGroup.randomQuestions")}
        name={["numberOfRandomQuestions"]}
      >
        <InputNumber max={ examGroup.numberOfQuestionsInGroup} min={0}/>
      </MyFormItem>
    </MyFormItemGroup>
  );
};
